<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire :currentPage="currentPageStep">
    <div class="check-list-form">
      <div class="content-type">
        <span>Registration Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <p>Please provide registration information in order for us to best serve you</p>
        <p class="heavy-text">Education Information</p>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Your Highest Education Level Achived:</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EducationInfo.HighestEducationAchieved'
                  )
                "
              >
                <el-select v-model="registrationAnswer.educationInfo.highestEducationAchieved" placeholder="Select">
                  <el-option
                    v-for="item in educationLevelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item" v-if="displayAreaOfStudy">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Area of Study?</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EducationInfo.AreaOfStudy'
                  )
                "
              >
                  <el-input
                    v-model="registrationAnswer.educationInfo.areaOfStudy"
                  />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Are you attending school?</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EducationInfo.AreYouAttendingSchool'
                  )
                "
              >
                <el-select v-model="registrationAnswer.educationInfo.areYouAttendingSchool" placeholder="Select">
                  <el-option
                    v-for="item in attendingSchoolOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Previous
              </el-button>
            </el-col>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Next
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { RegistrationQuestionnaire, TSLoading },
  data(){
    return{
      checklist: ['Asian', 'White'],
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        militaryService: {},
        veteranInfo: {},
        transitioningServiceMembers: {},
        militaryMemberSpouse: {},
        disability: {},
        householdInfo: {},
        publicAssistance: {},
        demographicInfo: {},
        ethnicOrigin: {},
        race: {
          raceSelection: []
        },
        language: {},
        educationInfo: {},
      },
      educationInfoEmpty: {
        highestEducationAchieved: null,
        areaOfStudy: null,
        areYouAttendingSchool: null,
      },
      jobSeekerId: null,
      educationLevelOptions: [
        { value: 'No School Grades Completed', label: 'No School Grades Completed' }, 
        { value: '1st Grade Completed', label: '1st Grade Completed' }, 
        { value: '2nd Grade Completed', label: '2nd Grade Completed' }, 
        { value: '3rd Grade Completed', label: '3rd Grade Completed' }, 
        { value: '4th Grade Completed', label: '4th Grade Completed' }, 
        { value: '5th Grade Completed', label: '5th Grade Completed' }, 
        { value: '6th Grade Completed', label: '6th Grade Completed' }, 
        { value: '7th Grade Completed', label: '7th Grade Completed' }, 
        { value: '8th Grade Completed', label: '8th Grade Completed' }, 
        { value: '9th Grade Completed', label: '9th Grade Completed' }, 
        { value: '10th Grade Completed', label: '10th Grade Completed' }, 
        { value: '11th Grade Completed', label: '11th Grade Completed' }, 
        { value: '12th Grade Completed & Did not receive diploma or equivalent', label: '12th Grade Completed & Did not receive diploma or equivalent' }, 
        { value: 'Certificate of Attendance/Completion (Disabled Individuals)', label: 'Certificate of Attendance/Completion (Disabled Individuals)' }, 
        { value: 'High School Equivalency Diploma', label: 'High School Equivalency Diploma' }, 
        { value: 'High School Diploma', label: 'High School Diploma' }, 
        { value: '1 Year at College or a Technical or Vocational School', label: '1 Year at College or a Technical or Vocational School' }, 
        { value: '2 Years at College or a Technical or Vocational School', label: '2 Years at College or a Technical or Vocational School' }, 
        { value: '3 Years at College or a Technical or Vocational School', label: '3 Years at College or a Technical or Vocational School' }, 
        { value: 'Vocational School Certificate', label: 'Vocational School Certificate' }, 
        { value: `Associate's Degree`, label: `Associate's Degree` }, 
        { value: `Bachelor's Degree`, label: `Bachelor's Degree` }, 
        { value: `Master's Degree`, label: `Master's Degree` }, 
        { value: 'Doctorate Degree', label: 'Doctorate Degree' }, 
        { value: 'Specialized Degree (e.g MD, DDS)', label: 'Specialized Degree (e.g MD, DDS)' }, 
      ],
      attendingSchoolOptions: [{
          value: 'Yes, Attending High School, Junior High, Middle, or Elementary School',
          label: 'Yes, Attending High School, Junior High, Middle, or Elementary School'
        }, {
          value: 'Yes, Attending An Alternate High School',
          label: 'Yes, Attending An Alternate High School'
        }, {
          value: 'Yes, Attending College or a Technical or Vocational School',
          label: 'Yes, Attending College or a Technical or Vocational School'
        }, {
          value: 'No, Not Attending Any School',
          label: 'No, Not Attending Any School'
        }],
      areaOfStudyOptions: [
        '1 Year at College or a Technical or Vocational School',
        '2 Years at College or a Technical or Vocational School',
        '3 Years at College or a Technical or Vocational School',
        'Vocational School Certificate',
        `Associate's Degree`,
        `Bachelor's Degree`,
        `Master's Degree`,
        'Doctorate Degree',
        'Specialized Degree (e.g MD, DDS)',
      ]
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    displayAreaOfStudy() {
      if (this.areaOfStudyOptions.includes(this.registrationAnswer.educationInfo.highestEducationAchieved)) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        if (res === null || res === undefined || res.priorityOfService === null) {
          this.$router.push({ name: "RegistrationQuestionnaireOne" });
        } else {
          this.registrationAnswer = res;

          this.registrationAnswer.educationInfo = this.registrationAnswer.educationInfo === null 
            ? this.educationInfoEmpty 
            : this.registrationAnswer.educationInfo;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "RegistrationQuestionnaireFour" });
    },
    updateRegistrationAnswers() {
      this.isLoading = true;
      this.registrationAnswer.educationInfo.isShowAreaOfStudy = this.displayAreaOfStudy;
      this.registrationAnswer.validatePageType = 5;

      if (!this.displayAreaOfStudy) this.registrationAnswer.educationInfo.areaOfStudy = null;        
          
      this.$store
        .dispatch("jobseeker/updateRegistrationAnswer", this.registrationAnswer)
        .then(res => {
          if (res) {
            this.$router.push({ name: "RegistrationQuestionnaireSix" });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
